import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { WorkspaceData } from './GraphData'
import { ModalUsageProps } from './Modal'
import modal from './Modal'
import * as cst from './cst'

interface WorkspaceBarProps {
  modalUsageProps : ModalUsageProps
  workspaces : WorkspaceData[] 
  fetchWorkspaces : Function
  workspaceParam : string
}

export const WorkspaceBar: React.FC<WorkspaceBarProps> = ({modalUsageProps, workspaces, fetchWorkspaces, workspaceParam}) => {
  const navigate = useNavigate()

  const handleSelect = e => {
    const targetUrl = e.target.value
    navigate(`/${targetUrl}`);
    (document.activeElement as HTMLElement).blur()
  }

  const getSelectorValue = () : string => {
    if(!workspaceParam){
      const currentWorkspace = localStorage.getItem("TTCurrentWorkspace")
      const match = workspaces.find(w => w.url === currentWorkspace)
      if(match){
        return match.url
      }
    }
    return workspaceParam
  }

  const workspaceModalError = async(e: string) => {
    const {clearHeldKeys, setModalUp} = modalUsageProps
    clearHeldKeys()
    setModalUp(true)
    try {
      const data = await modal(
        cst.MODAL_INFO,
        "Error",
        {"error":{value:e}}
      )  
      setModalUp(false)
    } catch (e) {
      setModalUp(false)
      console.log(e)
    }
  }

  const createNewWorkspace = async(workspaceData) => {
    const token = localStorage.getItem("TTAccessToken") 
    const url = localStorage.getItem("TTUrl")
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ workspaceData }),
    }
    try { 
      const res = await fetch(`${url}/api/workspaces?token=${token}`, requestOptions)
      return res 
    } catch (e) {
      console.log(e)
      return e
    }
  }
  
  const workspaceModalCreate = async() => {
    const {clearHeldKeys, setModalUp} = modalUsageProps
    clearHeldKeys()
    setModalUp(true)
    try {

      const data = await modal(
        cst.MODAL_FORM,
        "Create new workspace",
        {"title":{type:"string"},"url":{type:"string"}}
      )  
      setModalUp(false)
      if(!data){
        return undefined
      }
      if(!(data instanceof Object && data.title && data.url)){
        return "invalid"
      }
      return data 

    } catch (e) {
      setModalUp(false)
      console.log(e)
    }
  }

  const workspaceModalDelete = async(workspace) => {
    const {clearHeldKeys, setModalUp} = modalUsageProps
    clearHeldKeys()
    setModalUp(true)
    try {

      const data = await modal(
        cst.MODAL_CONFIRM,
        `Delete workspace ${workspace}?`
      )  

      if(data){
        const token = localStorage.getItem("TTAccessToken") 
        const url = localStorage.getItem("TTUrl")
        const requestOptions = {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        }
        try { 
          const res = await fetch(`${url}/api/workspaces/${workspace}?token=${token}`, requestOptions)
          return res 
        } catch (e) {
          console.log(e)
          return e
        }
      }


      setModalUp(false)
      console.log(data)

    } catch (e) {
      setModalUp(false)
      console.log(e)
    }
  }

  const updateWorkspace = async(workspaceUrl : string, workspaceData : WorkspaceData) => {
    const token = localStorage.getItem("TTAccessToken") 
    const url = localStorage.getItem("TTUrl")
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ workspaceData }),
    }
    try { 
      const res = await fetch(`${url}/api/workspaces/${workspaceUrl}?token=${token}`, requestOptions)
      return res 
    } catch (e) {
      console.log(e)
      return e
    }
  }

  const workspaceModalEdit = async(currentWorkspaces : WorkspaceData[], workspaceUrl : string)  => {
    const workspaceData : WorkspaceData = currentWorkspaces.find(w=>w.url===workspaceUrl)
    if(!workspaceData){
      return
    }
    const {clearHeldKeys, setModalUp} = modalUsageProps
    clearHeldKeys()
    setModalUp(true)
    try {

      const data = await modal(
        cst.MODAL_FORM,
        `Editing ${workspaceUrl}`,
        {
          "title":      {type:"string", value:workspaceData.title},
          "url":        {type:"string", value:workspaceData.url},
        }
      )  
      setModalUp(false)
      if(!data){
        return undefined
      }
      if(!(data instanceof Object && data.title && data.url)){
        return "invalid"
      }
      return data 

    } catch (e) {
      setModalUp(false)
      console.log(e)
    }
  }


  const workspaceModalManager = async (currentWorkspaces) => {
    const {clearHeldKeys, setModalUp} = modalUsageProps
    const modalContent = {}
    let workspacesToUse = currentWorkspaces || workspaces
    workspacesToUse.forEach(w=>{
      modalContent[w.title]={value:w.url}
    })
    clearHeldKeys()
    setModalUp(true)
    try {
      const choice = await modal(
        cst.MODAL_WORKSPACE_MANAGER,
        "Manage workspaces",
        modalContent
      )
      setModalUp(false)
      return choice

    } catch (e) {
      setModalUp(false)
      console.log(e)
    }
  }

  const workspaceModalMain = async () => {
    while(true){
      let currentWorkspaces = (await fetchWorkspaces()).workspaceData //We just grab them. We don't care about the so called state.
      let choice = await workspaceModalManager(currentWorkspaces)
      if(!(choice && choice instanceof Object && choice.action)){
        break
      }
      if(choice.action == "create"){
        const data = await workspaceModalCreate()
        if(!data){
          continue
        }
        if(data == "invalid"){
          await workspaceModalError("Invalid data.")
          continue
        }
        const response = await createNewWorkspace(data)
        if(!response.status || response.status!= 200){
          await workspaceModalError("Request failed.")
          continue
        }
      }

      else if(choice.action == "delete" && typeof choice.target === "string"){
        await workspaceModalDelete(choice.target)
      }
      else if(choice.action == "edit" && typeof choice.target === "string"){
        const data : any = await workspaceModalEdit(currentWorkspaces, choice.target)
        if(!data){
          continue
        }
        if(data == "invalid"){
          await workspaceModalError("Invalid data.")
          continue
        }
        const response = await updateWorkspace(choice.target, data)
        if(!response.status || response.status!= 200){
          await workspaceModalError("Request failed.")
          continue
        }
      }
    }
    
  }

  return (
    <div className="header-workspace-selector">
      Select workspace
      <select onChange={handleSelect} value={getSelectorValue()}>
        {workspaces && workspaces.map( w => <option value={w.url} key={w.url}>{w.title}</option>)}
      </select>
      <button onClick={workspaceModalMain}>Manage workspaces</button>
    </div>
  )
}
